import React from 'react'
import PropTypes from 'prop-types'

import {Tooltip, withStyles, Zoom} from '@material-ui/core'

const styles = theme => ({
    arrowPopper: {
        '&[x-placement*="bottom"] $arrowArrow': {
            top: 0,
            left: 0,
            marginTop: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent #000 transparent`
            }
        },
        '&[x-placement*="top"] $arrowArrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `#000 transparent transparent transparent`
            }
        },
        '&[x-placement*="right"] $arrowArrow': {
            left: 0,
            marginLeft: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent #000 transparent transparent`
            }
        },
        '&[x-placement*="left"] $arrowArrow': {
            right: 0,
            marginRight: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent #000`
            }
        },
        zIndex: 99999
    },
    arrowArrow: {
        position: 'absolute',
        fontSize: 7,
        width: '3em',
        height: '3em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid'
        }
    },

    tooltipLabel: {
        fontSize: '1em',
        backgroundColor: '#000'
    }
});

class ArrowToolTip extends React.Component {
    state = {
        arrowRef: null
    };

    handleArrowRef = node => {
        this.setState({
            arrowRef: node
        });
    };

    render() {
        const { classes, title, placement, className } = this.props;

        return (
            <Tooltip
                title={
                    <React.Fragment>
                        {title}
                        <span className={classes.arrowArrow} ref={this.handleArrowRef} />
                    </React.Fragment>
                }
                placement={placement}
                TransitionComponent={Zoom}
                classes={{ popper: classes.arrowPopper, tooltip: classes.tooltipLabel }}
                className={className}
                PopperProps={{
                    popperOptions: {
                        modifiers: {
                            arrow: {
                                enabled: Boolean(this.state.arrowRef),
                                element: this.state.arrowRef
                            }
                        }
                    }
                }}
            >
                {this.props.children}
            </Tooltip>
        );
    }
}

ArrowToolTip.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.element.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
}

ArrowToolTip.defaultProps = {
    placement: 'top'
}

export default withStyles(styles)(ArrowToolTip);
